
  import { Vue, Component, Prop } from "vue-property-decorator";
  import StarRating from 'vue-star-rating';

  @Component({
    components: {
      StarRating
    }
  })
  export default class RatingStars extends Vue{
    @Prop({ type: Number, default: 0 }) readonly value!: number;
    @Prop({ type: Number, default: 30 }) readonly starSize!: number;
    @Prop({ type: Boolean, default: false }) readonly readOnly!: number;
    @Prop({ type: Boolean, default: true }) readonly ratingShown!: boolean;
    @Prop({ type: Number, default: 0.5 }) readonly increment!: boolean;
  }
